<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="loading" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-places-categories'"
              :title="
                getTitle ? `${getTitle} категория места` : `Создать категорию места`
              "
            />
          </v-card-title>
          <v-card-text>
            <PageContent>
              <v-container>
                <InputTitleSlug
                  id-title="title"
                  :is-loading="loading || disabled"
                  :title="fields.title"
                  :title-error="validationErrors.title"
                  :slug="fields.slug"
                  :slug-error="validationErrors.slug"
                  :isSlugEnabled="!isNew"
                  @change:title="fields.title = $event"
                  @change:slug="fields.slug = $event"
                  @input:slug="$v.fields.slug.$touch"
                />
                <v-row>
                  <v-col cols="12">
                    <MediaFilePicker
                      :label="'Изображение'"
                      :multiple="false"
                      :file-type="$options.mediaTypesByKeys.IMAGE"
                      :value="fields.imageId"
                      @change="fields.imageId = $event"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <SeoSettings
                      :data="data"
                      :loading="loading || disabled"
                      @on-input-seo="fields = Object.assign({}, fields, $event)"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          v-if="isNew"
          ref="manageSidePanel"
          :is-new="isNew"
          :is-loading="loading"
          :language="language"
          :is-show-dtn-submit="disabled"
          :translations="fields.translations"
          :entity-type="'placeCategory'"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-place-category')"
          @cancel="$router.push({ name: 'page-places-categories' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        />
        <ManageSidePanel
          isShowSortOrder
          v-else-if="data"
          ref="manageSidePanel"
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :is-show-dtn-submit="disabled"
          :entity-id="data.id"
          :entity-type="'placeCategory'"
          :sortOrder="fields.sortOrder"
          :language="language"
          :translations="fields.translations"
          @delete="$emit('delete-place-category')"
          @cancel="$router.push({ name: 'page-places-categories' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        />
      </v-col>
    </v-row>
  </form>
</template>
<script>
import validationRules from './validation-rules.js'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import SeoSettings from '@/components/seo-settings'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import MediaFilePicker from '@/components/media-file-picker'
import { mixForm } from '@/utils/form.mix.js'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  extends: FormAbstract,
  mixins: [validationTranslations, mixForm],
  name: 'FormPlaceCategory',
  mediaTypesByKeys: mediaTypesByKeys(),
  validationRules,
  components: {
    PageContent,
    InputTitleSlug,
    ManageSidePanel,
    SeoSettings,
    FormHeader,
    MediaFilePicker,
    ProgressCircular
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: {
        title: null,
        slug: undefined,
        imageId: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImage: null,
        translations: { ru: { isEnabled: true } },
        sortOrder: null
      }
    }
  },
  computed: {
    getTitle () {
      if (this.data) {
        return this.data?.title || ''
      }
      return null
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    }
  },
  watch: {
    data (val) {
      this.populate(val)
      this.fields.imageId = val?.image?.id || null
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.seoOgImage
      this.$emit('submit', payload)
    }
  }
}
</script>
